export default __webpack_public_path__ + "static/media/header_paper.9deeb2c3.webp";